import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

/**
 * 获取权限菜单树
 * @param groups // 菜单分组id数组， eq. [1,2,3]
 */
export function getAuthMenuTree(groups) {
  return request({
    url: cmsServerContext + '/customerRoleMenu/authMenuTree',
    method: 'post',
    data: groups
  })
}

/**
 * 根据客户角色id查询菜单id集合
 * @param customerRoleId
 */
export function getMenuIds(customerRoleId) {
  return request({
    url: cmsServerContext + '/customerRoleMenu/getMenuIds/' + customerRoleId,
    method: 'get'
  })
}

/**
 * 保存角色菜单权限
 * @param customerRoleId
 * @param menuIds
 */
export function saveWithMenuIds(customerRoleId, menuIds) {
  return request({
    url: cmsServerContext + '/customerRoleMenu/saveWithMenuIds/' + customerRoleId,
    method: 'post',
    data: menuIds
  })
}

export function warningMenu(map) {
  return request({
    url: cmsServerContext + '/customerRoleMenu/warningMenu',
    method: 'post',
    data : map
  })
}